import { MarkdownRenderer } from '@repo/ui-web';

const markdown = `# Terms Summary

## Data use

We process user data for:

- Account management
- Security monitoring
- Product analytics

| Region | Retention |
| --- | --- |
| US | 12 months |
| EU | 6 months |

> This preview uses the design-system markdown renderer.
`;

export function MarkdownRendererShowcase() {
  return (
    <div className="max-w-2xl rounded-md border border-input p-4">
      <MarkdownRenderer markdown={markdown} />
    </div>
  );
}

